import React from 'react'
import Box from '@mui/material/Box'
import theme from '../../theme'

const LogoDisplay = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        padding: '0px',
        justifyContent: 'center',
        alignItems: 'center',
        display: {
          xs: 'none',
          sm: 'none',
          md: 'none',
          lg: 'flex',
          xl: 'flex'
        },
        backgroundColor: theme.palette['accent-500']
      }}
    >
      <img
        style={{
          width: '60%'
        }}
        src="/images/login-image-placeholder.svg"
        alt="Grocery TV"
      />
    </Box>
  )
}

export default LogoDisplay
